module.exports = __webpack_public_path__ + "img/s6_img@2x.e11745ce.png";